import classNames from 'clsx';
import type React from 'react';

import type { WidgetType } from '@swf/core/types/Widget';

import styles from './ProviderLogo.scss';
import { PROVIDER_LOGO_MAPPING } from './constants';

export interface Props {
  developer: keyof typeof PROVIDER_LOGO_MAPPING;
  contentType: WidgetType;
}

const ProviderLogo: React.FC<Props> = ({ developer, contentType }) =>
  PROVIDER_LOGO_MAPPING?.[developer] && (
    <div
      className={classNames(styles.providerLogo, PROVIDER_LOGO_MAPPING[developer], {
        [styles.gameDeck]: contentType === 'casino_game_deck'
      })}
    />
  );

export default ProviderLogo;
